var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full h-full top-0 left-0 flex items-center justify-center",class:{'absolute':!_vm.inline, 'blur': _vm.bgBlur}},[_c('div',{staticClass:"lds-dual-ring z-50"})])
}
var staticRenderFns = []

export { render, staticRenderFns }